"use strict";

var _regeneratorRuntime = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/slicedToArray");

var _assertThisInitialized = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _classCallCheck = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveDocument = exports.BaseResolver = exports.makeDocumentFromString = exports.YamlParseError = exports.ResolveError = exports.Source = void 0;

var fs = require("fs");

var path = require("path");

var url = require("url");

var ref_utils_1 = require("./ref-utils");

var types_1 = require("./types");

var utils_1 = require("./utils");

var Source = /*#__PURE__*/function () {
  function Source(absoluteRef, body, mimeType) {
    _classCallCheck(this, Source);

    this.absoluteRef = absoluteRef;
    this.body = body;
    this.mimeType = mimeType;
  } // pass safeLoad as argument to separate it from browser bundle


  _createClass(Source, [{
    key: "getAst",
    value: function getAst(safeLoad) {
      var _a;

      if (this._ast === undefined) {
        this._ast = (_a = safeLoad(this.body, {
          filename: this.absoluteRef
        })) !== null && _a !== void 0 ? _a : undefined; // fix ast representation of file with newlines only

        if (this._ast && this._ast.kind === 0 && // KIND.scalar = 0
        this._ast.value === '' && this._ast.startPosition !== 1) {
          this._ast.startPosition = 1;
          this._ast.endPosition = 1;
        }
      }

      return this._ast;
    }
  }, {
    key: "getLines",
    value: function getLines() {
      if (this._lines === undefined) {
        this._lines = this.body.split(/\r\n|[\n\r]/g);
      }

      return this._lines;
    }
  }]);

  return Source;
}();

exports.Source = Source;

var ResolveError = /*#__PURE__*/function (_Error) {
  _inherits(ResolveError, _Error);

  var _super = _createSuper(ResolveError);

  function ResolveError(originalError) {
    var _this;

    _classCallCheck(this, ResolveError);

    _this = _super.call(this, originalError.message);
    _this.originalError = originalError; // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_this), ResolveError.prototype);
    return _this;
  }

  return ResolveError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ResolveError = ResolveError;
var jsYamlErrorLineColRegexp = /\((\d+):(\d+)\)$/;

var YamlParseError = /*#__PURE__*/function (_Error2) {
  _inherits(YamlParseError, _Error2);

  var _super2 = _createSuper(YamlParseError);

  function YamlParseError(originalError, source) {
    var _this2;

    _classCallCheck(this, YamlParseError);

    _this2 = _super2.call(this, originalError.message.split('\n')[0]);
    _this2.originalError = originalError;
    _this2.source = source; // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_this2), YamlParseError.prototype);

    var _ref = _this2.message.match(jsYamlErrorLineColRegexp) || [],
        _ref2 = _slicedToArray(_ref, 3),
        line = _ref2[1],
        col = _ref2[2];

    _this2.line = parseInt(line, 10);
    _this2.col = parseInt(col, 10);
    return _this2;
  }

  return YamlParseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.YamlParseError = YamlParseError;

function makeDocumentFromString(sourceString, absoluteRef) {
  var source = new Source(absoluteRef, sourceString);

  try {
    return {
      source: source,
      parsed: utils_1.parseYaml(sourceString, {
        filename: absoluteRef
      })
    };
  } catch (e) {
    throw new YamlParseError(e, source);
  }
}

exports.makeDocumentFromString = makeDocumentFromString;

var BaseResolver = /*#__PURE__*/function () {
  function BaseResolver() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      http: {
        headers: []
      }
    };

    _classCallCheck(this, BaseResolver);

    this.config = config;
    this.cache = new Map();
  }

  _createClass(BaseResolver, [{
    key: "getFiles",
    value: function getFiles() {
      return new Set(Array.from(this.cache.keys()));
    }
  }, {
    key: "resolveExternalRef",
    value: function resolveExternalRef(base, ref) {
      if (ref_utils_1.isAbsoluteUrl(ref)) {
        return ref;
      }

      if (base && ref_utils_1.isAbsoluteUrl(base)) {
        return url.resolve(base, ref);
      }

      return path.resolve(base ? path.dirname(base) : process.cwd(), ref);
    }
  }, {
    key: "loadExternalRef",
    value: function loadExternalRef(absoluteRef) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$utils_1$readFi, body, mimeType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!ref_utils_1.isAbsoluteUrl(absoluteRef)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return utils_1.readFileFromUrl(absoluteRef, this.config.http);

              case 4:
                _yield$utils_1$readFi = _context.sent;
                body = _yield$utils_1$readFi.body;
                mimeType = _yield$utils_1$readFi.mimeType;
                return _context.abrupt("return", new Source(absoluteRef, body, mimeType));

              case 10:
                _context.t0 = Source;
                _context.t1 = absoluteRef;
                _context.next = 14;
                return fs.promises.readFile(absoluteRef, 'utf-8');

              case 14:
                _context.t2 = _context.sent;
                return _context.abrupt("return", new _context.t0(_context.t1, _context.t2));

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t3 = _context["catch"](0);
                throw new ResolveError(_context.t3);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 18]]);
      }));
    }
  }, {
    key: "parseDocument",
    value: function parseDocument(source) {
      var isRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _a;

      var ext = source.absoluteRef.substr(source.absoluteRef.lastIndexOf('.'));

      if (!['.json', '.json', '.yml', '.yaml'].includes(ext) && !((_a = source.mimeType) === null || _a === void 0 ? void 0 : _a.match(/(json|yaml|openapi)/)) && !isRoot // always parse root
      ) {
          return {
            source: source,
            parsed: source.body
          };
        }

      try {
        return {
          source: source,
          parsed: utils_1.parseYaml(source.body, {
            filename: source.absoluteRef
          })
        };
      } catch (e) {
        throw new YamlParseError(e, source);
      }
    }
  }, {
    key: "resolveDocument",
    value: function resolveDocument(base, ref) {
      var isRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var absoluteRef, cachedDocument, doc;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                absoluteRef = this.resolveExternalRef(base, ref);
                cachedDocument = this.cache.get(absoluteRef);

                if (!cachedDocument) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", cachedDocument);

              case 4:
                doc = this.loadExternalRef(absoluteRef).then(function (source) {
                  return _this3.parseDocument(source, isRoot);
                });
                this.cache.set(absoluteRef, doc);
                return _context2.abrupt("return", doc);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return BaseResolver;
}();

exports.BaseResolver = BaseResolver;

function pushRef(head, node) {
  return {
    prev: head,
    node: node
  };
}

function hasRef(head, node) {
  while (head) {
    if (head.node === node) {
      return true;
    }

    head = head.prev;
  }

  return false;
}

var unknownType = {
  name: 'unknown',
  properties: {}
};
var resolvableScalarType = {
  name: 'scalar',
  properties: {}
};

function resolveDocument(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var rootDocument, externalRefResolver, rootType, resolvedRefMap, seedNodes, resolvePromises, resolved, resolveRefsInParallel;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            resolveRefsInParallel = function _resolveRefsInParalle(rootNode, rootNodeDocument, rootNodePointer, type) {
              var rootNodeDocAbsoluteRef = rootNodeDocument.source.absoluteRef;
              walk(rootNode, type, rootNodeDocAbsoluteRef + rootNodePointer);

              function walk(node, type, nodeAbsoluteRef) {
                if (typeof node !== 'object' || node === null) {
                  return;
                }

                var nodeId = "".concat(type.name, "::").concat(nodeAbsoluteRef);

                if (seedNodes.has(nodeId)) {
                  return;
                }

                seedNodes.add(nodeId);

                if (Array.isArray(node)) {
                  var itemsType = type.items; // we continue resolving unknown types, but stop early on known scalars

                  if (type !== unknownType && itemsType === undefined) {
                    return;
                  }

                  for (var i = 0; i < node.length; i++) {
                    walk(node[i], itemsType || unknownType, ref_utils_1.joinPointer(nodeAbsoluteRef, i));
                  }

                  return;
                }

                for (var _i = 0, _Object$keys = Object.keys(node); _i < _Object$keys.length; _i++) {
                  var propName = _Object$keys[_i];
                  var propValue = node[propName];
                  var propType = type.properties[propName];
                  if (propType === undefined) propType = type.additionalProperties;
                  if (typeof propType === 'function') propType = propType(propValue, propName);
                  if (propType === undefined) propType = unknownType;

                  if (!types_1.isNamedType(propType) && (propType === null || propType === void 0 ? void 0 : propType.directResolveAs)) {
                    propType = propType.directResolveAs;
                    propValue = {
                      $ref: propValue
                    };
                  }

                  if (propType && propType.name === undefined && propType.resolvable !== false) {
                    propType = resolvableScalarType;
                  }

                  if (!types_1.isNamedType(propType) || typeof propValue !== 'object') {
                    continue;
                  }

                  walk(propValue, propType, ref_utils_1.joinPointer(nodeAbsoluteRef, ref_utils_1.escapePointer(propName)));
                }

                if (ref_utils_1.isRef(node)) {
                  var promise = followRef(rootNodeDocument, node, {
                    prev: null,
                    node: node
                  }).then(function (resolvedRef) {
                    if (resolvedRef.resolved) {
                      resolveRefsInParallel(resolvedRef.node, resolvedRef.document, resolvedRef.nodePointer, type);
                    }
                  });
                  resolvePromises.push(promise);
                }
              }

              function followRef(document, ref, refStack) {
                return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var _ref_utils_1$parseRef, uri, pointer, isRemote, targetDoc, _resolvedRef, _refId, resolvedRef, target, segments, _iterator, _step, segment, refId;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!hasRef(refStack.prev, ref)) {
                            _context3.next = 2;
                            break;
                          }

                          throw new Error('Self-referencing circular pointer');

                        case 2:
                          _ref_utils_1$parseRef = ref_utils_1.parseRef(ref.$ref), uri = _ref_utils_1$parseRef.uri, pointer = _ref_utils_1$parseRef.pointer;
                          isRemote = uri !== null;
                          _context3.prev = 4;

                          if (!isRemote) {
                            _context3.next = 11;
                            break;
                          }

                          _context3.next = 8;
                          return externalRefResolver.resolveDocument(document.source.absoluteRef, uri);

                        case 8:
                          _context3.t0 = _context3.sent;
                          _context3.next = 12;
                          break;

                        case 11:
                          _context3.t0 = document;

                        case 12:
                          targetDoc = _context3.t0;
                          _context3.next = 21;
                          break;

                        case 15:
                          _context3.prev = 15;
                          _context3.t1 = _context3["catch"](4);
                          _resolvedRef = {
                            resolved: false,
                            isRemote: isRemote,
                            document: undefined,
                            error: _context3.t1
                          };
                          _refId = document.source.absoluteRef + '::' + ref.$ref;
                          resolvedRefMap.set(_refId, _resolvedRef);
                          return _context3.abrupt("return", _resolvedRef);

                        case 21:
                          resolvedRef = {
                            resolved: true,
                            document: targetDoc,
                            isRemote: isRemote,
                            node: document.parsed,
                            nodePointer: '#/'
                          };
                          target = targetDoc.parsed;
                          segments = pointer;
                          _iterator = _createForOfIteratorHelper(segments);
                          _context3.prev = 25;

                          _iterator.s();

                        case 27:
                          if ((_step = _iterator.n()).done) {
                            _context3.next = 55;
                            break;
                          }

                          segment = _step.value;

                          if (!(typeof target !== 'object')) {
                            _context3.next = 34;
                            break;
                          }

                          target = undefined;
                          return _context3.abrupt("break", 55);

                        case 34:
                          if (!(target[segment] !== undefined)) {
                            _context3.next = 39;
                            break;
                          }

                          target = target[segment];
                          resolvedRef.nodePointer = ref_utils_1.joinPointer(resolvedRef.nodePointer, ref_utils_1.escapePointer(segment));
                          _context3.next = 53;
                          break;

                        case 39:
                          if (!ref_utils_1.isRef(target)) {
                            _context3.next = 51;
                            break;
                          }

                          _context3.next = 42;
                          return followRef(targetDoc, target, pushRef(refStack, target));

                        case 42:
                          resolvedRef = _context3.sent;
                          targetDoc = resolvedRef.document || targetDoc;

                          if (!(typeof resolvedRef.node !== 'object')) {
                            _context3.next = 47;
                            break;
                          }

                          target = undefined;
                          return _context3.abrupt("break", 55);

                        case 47:
                          target = resolvedRef.node[segment];
                          resolvedRef.nodePointer = ref_utils_1.joinPointer(resolvedRef.nodePointer, ref_utils_1.escapePointer(segment));
                          _context3.next = 53;
                          break;

                        case 51:
                          target = undefined;
                          return _context3.abrupt("break", 55);

                        case 53:
                          _context3.next = 27;
                          break;

                        case 55:
                          _context3.next = 60;
                          break;

                        case 57:
                          _context3.prev = 57;
                          _context3.t2 = _context3["catch"](25);

                          _iterator.e(_context3.t2);

                        case 60:
                          _context3.prev = 60;

                          _iterator.f();

                          return _context3.finish(60);

                        case 63:
                          resolvedRef.node = target;
                          resolvedRef.document = targetDoc;
                          refId = document.source.absoluteRef + '::' + ref.$ref;

                          if (!(resolvedRef.document && ref_utils_1.isRef(target))) {
                            _context3.next = 70;
                            break;
                          }

                          _context3.next = 69;
                          return followRef(resolvedRef.document, target, pushRef(refStack, target));

                        case 69:
                          resolvedRef = _context3.sent;

                        case 70:
                          resolvedRefMap.set(refId, resolvedRef);
                          return _context3.abrupt("return", Object.assign({}, resolvedRef));

                        case 72:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[4, 15], [25, 57, 60, 63]]);
                }));
              }
            };

            rootDocument = opts.rootDocument, externalRefResolver = opts.externalRefResolver, rootType = opts.rootType;
            resolvedRefMap = new Map();
            seedNodes = new Set(); // format "${type}::${absoluteRef}${pointer}"

            resolvePromises = [];
            resolveRefsInParallel(rootDocument.parsed, rootDocument, '#/', rootType);

          case 6:
            _context4.next = 8;
            return Promise.all(resolvePromises);

          case 8:
            resolved = _context4.sent;

          case 9:
            if (resolvePromises.length !== resolved.length) {
              _context4.next = 6;
              break;
            }

          case 10:
            return _context4.abrupt("return", resolvedRefMap);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.resolveDocument = resolveDocument;